export const STATE_PARAM_NAME = "state";

export const SUPPORT_ARTICLE =
    "https://support.accurx.com/en/articles/10869989-why-do-i-need-to-link-my-workspace";
